"use client";

import React from "react";
import { Icon, Portal, Select, Stack, Text, createListCollection, useSelectContext } from "@chakra-ui/react";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import ChevronDownSvgIcon from "@/shared/icons/ChevronDownSvgIcon";
import CheckSvgIcon from "@/shared/icons/CheckSvgIcon";
import { useTranslations } from "next-intl";

export function SortSelect() {
  const t = useTranslations()
  const router = useRouter();
  const params = useSearchParams();
  const pathname = usePathname();

  function handleChange(value: string) {
    const newSort = value;
    const query = new URLSearchParams(params?.toString() || "");
    query.set("sort", newSort);

    const queryString = query.toString();
    const url = queryString ? `${pathname}?${queryString}` : pathname;
    router.push(url);
  }

  const sorts = createListCollection({
    items: [
      { label: t("default"), value: "default" },
      { label: t("price_ascending"), value: "price_asc" },
      { label: t("price_descending"), value: "price_desc" },
    ],
  });

  const currentValue = params.get("sort") || "default";

  const SelectTrigger = () => {
    const select = useSelectContext()
    const items = select.selectedItems as any[]
    return (
      <Stack direction="row" align="center" gap="8px" cursor={"pointer"}
        {...(select.getTriggerProps() as any)}>
        <Text textStyle="medium16" color="#9E9F9D">{t('products_sort')}:</Text>
        <Text textStyle="medium16">{select.hasSelectedItems ? items[0].label : t('select_value')}</Text>
        <Icon as={ChevronDownSvgIcon} boxSize={5} color="text.secondary" />
      </Stack>
    )
  }
  return (
    <Select.Root
      collection={sorts}
      variant={undefined}
      value={[currentValue]}
      onValueChange={(item) => handleChange(item.value[0])}
      w={"auto"}
    >
      <Select.HiddenSelect />
      <Select.Control>
        <SelectTrigger />
      </Select.Control>

      <Portal>
        <Select.Positioner>
          <Select.Content borderRadius={"none"}>
            {sorts.items.map((s) => (
              <Select.Item item={s} key={s.value} textStyle="medium16" borderRadius={"none"} padding="8px 16px">
                {s.label}

                <Select.ItemIndicator >
                  <Icon color="brand"><CheckSvgIcon /></Icon>
                </Select.ItemIndicator>
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Positioner>
      </Portal>
    </Select.Root>
  );
}
